import { Checkbox, Space } from 'antd';
import React, { ReactElement, ReactNode, useEffect, useRef, useState } from 'react';
import Panel from '../../../../shared/components/card/Panel';
import { EventCalenderProps, CalendarEvent } from './../../../../shared/models/hospitalProfile.model';
import { CAL_EVENTS_CATEGORY } from './../../../../shared/constants/commonConstants';
import _ from 'lodash';
import NoDataFound from '../../../inventry/shared/NoDataFound';

const ScheduledCalendars = ({ events, onSaveCalendar }: EventCalenderProps): ReactElement => {
  const [specEvents, setSpecEvents] = useState([] as any);
  const [specEvent, setSpecEvent] = useState(events as CalendarEvent[]);
  const [isMyCalActive, setIsMyCalActive] = useState(false);
  const [isFilterDisabled, setIsFilterDisabled] = useState(false);
  const ref = useRef({ typeIds: CAL_EVENTS_CATEGORY as any });

  useEffect((): void => {
    if (events && events.length > 0 && !specEvents?.length) {
      const specCalendars = events.filter(({ resource: { eventInfo: { typeId } } }: CalendarEvent): boolean => {
        return typeId !== CAL_EVENTS_CATEGORY[0] && typeId !== 0;
      });
      setSpecEvent(specCalendars);
      if (specCalendars && specCalendars.length > 0) {
        setSpecEvents(_.uniqBy(specCalendars.map((v: any): any => v.resource.eventInfo), 'typeId'));
      }

    }
    // eslint-disable-next-line
  }, [events]);

  useEffect((): void => {
    if (events && events.length > 0 && !isFilterDisabled
      && (ref.current.typeIds.findIndex((v: any): any => v === CAL_EVENTS_CATEGORY[0]) > -1)) {
      if (events.length > specEvents.length) {
        setIsMyCalActive(true);
      } else {
        setIsMyCalActive(false);
      }
    }
    // eslint-disable-next-line
  }, [events, specEvents]);

  const onCalFilter = (typeId: number): void => {
    getClassName(typeId);
    if (typeId !== CAL_EVENTS_CATEGORY[0]) {
      ref.current.typeIds = ref.current.typeIds.filter((d: any): boolean => d === CAL_EVENTS_CATEGORY[0]);
      const filteredEvents = specEvent.map((v: CalendarEvent): CalendarEvent => {
        if (v.resource?.eventInfo.typeId === typeId) {
          v.resource.eventInfo.isActive = !v.resource.eventInfo.isActive;
          return v;
        } else {
          return v;
        }
      });
      ref.current.typeIds = filteredEvents.filter((vv: any): any => vv.resource.eventInfo.isActive)
        .map((v: any): any => v.resource.eventInfo.typeId);
      if (isMyCalActive) {
        ref.current.typeIds.unshift(CAL_EVENTS_CATEGORY[0]);
        setIsFilterDisabled(true);
      }
      setSpecEvents(_.uniqBy(filteredEvents.map((v: any): any => v.resource.eventInfo), 'typeId'));
      // setSpecEvents([...filteredEvents]);
    } else {
      !isMyCalActive ? ref.current.typeIds.push(CAL_EVENTS_CATEGORY[0]) :
        ref.current.typeIds = ref.current.typeIds.filter((d: any): boolean => d !== CAL_EVENTS_CATEGORY[0]);
      setIsMyCalActive(!isMyCalActive);
    }
    onSaveCalendar(true, ref.current.typeIds);
    setTimeout((): void => {
      setIsFilterDisabled(false);
    }, 1000);
  };

  const getClassName = (typeId: number): string => {
    if ((!specEvents) || (specEvents && !specEvents.length)) {
      return 'filter-inactive';
    } else {
      const typeIds = _.uniq(ref.current.typeIds);
      return (typeIds.length === 1 && typeIds[0] === typeId) ? 'filter-inactive' : '';
    }
  };

  return (
    <Panel title={'Calendars'}>
      <Space direction={'vertical'} className="calendar-checkbox">
        {(specEvents && specEvents.length > 0) &&
          specEvents.map(({ isActive, typeId, typeName }: any, i: number): ReactNode => (
            <p key={i}><Checkbox checked={isActive} className={getClassName(typeId)}
              onChange={(): void => onCalFilter(typeId)}>{typeName}</Checkbox></p>
          ))}
        {events && events.length > 0 && (
          <p>
            <Checkbox checked={isMyCalActive} className={getClassName(CAL_EVENTS_CATEGORY[0])}
              onChange={(): void => onCalFilter(CAL_EVENTS_CATEGORY[0])}>{'My Calendar'}</Checkbox>
          </p>
        )}
      </Space>
      {events && !events.length && (
        <NoDataFound />
      )}
    </Panel>
  );
};

export default ScheduledCalendars;
